import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router'

import { Card, Icon } from 'semantic-ui-react'

const MinionCounter = (props) => {
  const minions = props.minions
  const up_minions = _.filter(minions, 'status')
  const color = (
    (_.size(minions) === _.size(up_minions) &&
     _.size(minions) !== 0) ? 'green': 'red'
  )

  console.log('minions: ' + minions + ' up: '+up_minions)

  return (
    <Card>
      <Card.Content textAlign="center">
        <Icon name="cubes" color={color} size={'huge'} />
      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>{_.size(up_minions)} / {_.size(minions)}</Card.Header>
      </Card.Content>
      <Card.Description textAlign="center">
        On {_.size(minions)} minions detected on the platform, {_.size(up_minions)} minions were alive recently.
      </Card.Description>
    </Card>
  )

}
MinionCounter.displayName = 'MinionCounter'
MinionCounter.propTypes = {
  minions: PropTypes.object
}
export default MinionCounter



// WEBPACK FOOTER //
// ./src/components/dashboard/MinionCounter.js